import React from "react";
import { Link } from "react-router-dom";
import bgheader3png from "../../assets/images/bg-header-3.png";

function Shared(props) {
  return (
    <>
      <header className="dx-header dx-box-1">
        <div className="container">
          <div className="bg-image bg-image-parallax">
            <img src={bgheader3png} className="jarallax-img" alt="" />
            <div style={{ backgroundColor: "rgba(27, 27, 27, 0.8)" }}></div>
          </div>
          <div className="row justify-content-center">
            <div className="col-xl-7">
              <h1 className="h2 mb-30 text-white text-center">
                How can we help you?
              </h1>
              <form action="#" className="dx-form dx-form-group-inputs">
                <input
                  type="text"
                  name=""
                  value=""
                  className="form-control"
                  placeholder="Keyword search..."
                />
                <button className="dx-btn dx-btn-lg">Search</button>
              </form>
            </div>
          </div>
        </div>
      </header>
      <div className="dx-box bg-white">
        <div className="container">
          <ul className="dx-links text-center">
            <li>
              <Link to="/help-center">Support Home</Link>
            </li>
            <li>
              <Link to="/documentations">Documentations</Link>
            </li>
            <li className="active">
              <Link to="/articles">Knowledge Base</Link>
            </li>
            <li>
              <Link to="/forums">Forums</Link>
            </li>
            <li>
              <Link to="/ticket">Ticket System</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="dx-separator"></div>
    </>
  );
}

export default Shared;
